<template>
  <div class="news-article-block block_2 flex-col">
    <div v-for="(item, index) in items" :key="'row-'+index" class="article-row">
      <div class="image-text flex-row justify-between" @click="goDetail(item)">
        <div class="thumb-box">
          <img class="article-thumb" referrerpolicy="no-referrer" :src="item.img ? item.img : defaultThumb" />
        </div>
        <div class="text-group flex-col">
          <span class="article-title">{{ item.title }}</span>
          <span class="article-date">{{ item.date || item.publishTime || item.createTime }}</span>
        </div>
      </div>
      <img v-if="index < items.length - 1" class="divider-img" referrerpolicy="no-referrer" src="../assets/img/divider-line.png" />
    </div>
    <div class="empty-state" v-if="items.length === 0">
      <p class="empty-state-text">暂无数据</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsArticleBlock',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      defaultThumb: require('../assets/img/article-thumb-1.png')
    }
  },
  methods: {
    goDetail(item) {
      if (item && item.id) {
        this.$router.push('/article/' + item.id)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.block_2 {
  box-shadow: 0px 2px 14px 0px rgba(204, 204, 204, 0.5);
  background-color: rgba(255, 255, 255, 1);
  border-radius: 8px;
  width: 343px;
  align-self: center;
  margin-top: 10px;
  padding: 12px 13px 13px 12px;

  .article-row {
    margin-top: 10px;
    &:first-child {
      margin-top: 0;
    }
  }

  .image-text {
    width: 318px;
    cursor: pointer;
    transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    &:active {
      transform: scale(0.97);
      opacity: 0.85;
    }

    .thumb-box {
      width: 114px;
      height: 76px;
      overflow: hidden;
      border-radius: 4px;
    }
    .article-thumb {
      width: 100%;
    }

    .text-group {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .article-title {
        width: 185px;
        height: 54px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        line-height: 18px;
        text-align: justify;
        font-style: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }

      .article-date {
        overflow: hidden;
        text-overflow: ellipsis;
        color: rgba(142, 142, 142, 1);
        font-size: 12px;
        text-align: left;
        white-space: nowrap;
        line-height: 17px;
      }
    }
  }

  .divider-img {
    width: 318px;
    height: 1px;
    margin-top: 10px;
  }
}
</style>
